import { render, staticRenderFns } from "./PregledPodsetnikaOsoba.vue?vue&type=template&id=89adb0ac&scoped=true&"
import script from "./PregledPodsetnikaOsoba.vue?vue&type=script&lang=ts&"
export * from "./PregledPodsetnikaOsoba.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "89adb0ac",
  null
  
)

export default component.exports